module.exports = __webpack_public_path__ + "b96e6dc2a60c7dbe6ec5a4a4fb0163c1.png";